<template>
  <!-- 活动  -->
  <div class="second-page-wrapper">
    <div class="second-page-wrapper-left">
      <news-slide :slideList="titleList"></news-slide>
    </div>
    <div class="second-page-wrapper-right">
      <router-view></router-view>
    </div>
  </div>
</template>
<style scoped>
.second-page-wrapper {
  width: 1230px;
  margin: 0 auto 30px;
  display: flex;
}
.second-page-wrapper-left{
   width: 310px;
  margin-right: 30px;
}
.second-page-wrapper-right{
  width: 890px;
}
</style>

<script>
import newsSlide from "./slide.vue";
export default {
  data() {
    return {
      titleList: [
         {
          title: "重要活动",
          annoceFlag: "1"
        },
        {
          title: "重要公告",
          annoceFlag: "2"
        },
      ]
    };
  },
  components: {
    newsSlide
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/Announce/index.vue